import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useContext, useEffect, useRef } from 'react';
import olOverlay from 'ol/Overlay';
import { MapContext } from './MapProvider';
const Overlay = (props) => {
    const { children, id, offset, position, positioning, stopEvent, insertFirst, style, autoPan } = props;
    const ref = useRef(null);
    const map = useContext(MapContext);
    const [overlay] = useState(new olOverlay({
        id: id,
        offset: offset,
        position: position,
        positioning: positioning,
        stopEvent: stopEvent,
        insertFirst: insertFirst,
        autoPan,
    }));
    useEffect(() => {
        if (!ref.current)
            return;
        overlay.setElement(ref.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current]);
    useEffect(() => {
        if (!map)
            return;
        map.addOverlay(overlay);
        return () => {
            map.removeOverlay(overlay);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);
    useEffect(() => {
        if (!offset)
            return;
        overlay.setOffset(offset);
    }, [overlay, offset]);
    useEffect(() => {
        if (!position)
            return;
        overlay.setPosition(position);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [position]);
    return (_jsx("div", { ref: ref, style: { ...style }, children: children }));
};
export default Overlay;
